import * as React from 'react';
import { ActionButton, fetchApi, notifyError, notifyResponse } from 'gossamer-front-end';
import { AdminUnbookSingleTicketRequest, BookingExtendedView, BookingView } from 'cb-model';

export interface UnbookMemberFromEventButtonProps {
  value: string;
  handleSuccess?: () => void;
}

export const UnbookUserFromEventButton: React.FC<UnbookMemberFromEventButtonProps> = (props) => {
  return (
    <ActionButton
      label="Unbook"
      size="sm"
      variant="danger"
      execute={async (resetCache) => {
        try {
          const payload: AdminUnbookSingleTicketRequest = {
            bookingId: parseInt(props.value),
          };
          const response = await fetchApi('POST', `/main/unbook-user-from-event`, payload);
          resetCache(BookingView.id);
          resetCache(BookingExtendedView.id);
          notifyResponse(response);
          props.handleSuccess?.();
        } catch (e) {
          notifyError(e, 'An error occurred while unbooking the member from the event');
        }
      }}
    />
  );
};
